module.exports = __webpack_public_path__ + "static/media/swachta.5743d713.jpg";